import download from "src/helpers/download";
import swal from "sweetalert2";
import "whatwg-fetch";

export default {
    resetAllState({ commit }) {
        commit("reset");
        commit("deliveryRequest/reset");
    },
    async downloadFile(context, file) {
        const result = await fetch("/api/download", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
            },
            body: JSON.stringify({
                url: file.url,
            }),
        });
        let errorMsg = null;
        switch (result.status) {
            case 401:
                errorMsg = "You are not authorized to download this file.";
                break;
            case 404:
                errorMsg = "File not found.";
                break;
            case 500:
                errorMsg = "Could not download file. Please try again later.";
                break;
            default:
                break;
        }
        if (errorMsg) {
            swal({
                title: "Error!",
                text: errorMsg,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
            });
        } else {
            const blob = await result.blob();
            download(blob, file.downloadName || file.name, blob.type);
        }
    },
    async getImage(context, url) {
        const result = await fetch("/api/download", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
            },
            body: JSON.stringify({
                url,
            }),
        });
        let errorMsg = null;
        switch (result.status) {
            case 401:
                errorMsg = "You are not authorized to download this file.";
                break;
            default:
                break;
        }
        if (errorMsg) {
            swal({
                title: "Error!",
                text: errorMsg,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
            });
            return null;
        }
        const blob = await result.blob();
        return URL.createObjectURL(blob);
    },
};
